t = require('app/scripts/views/internal/teacup-with-helpers')('member_session_list')

module.exports = ->
  t.div '.js-sessions'

  t.input '.js-log-out-other', { type: 'button', value: t.l('log-out-other-sessions') }
